import TextField from "../components/common/TextField";
import { useFormik } from "formik";
import { loginSchema } from "../configs";
import Button from "../components/common/Button";
import { Navigate } from "react-router-dom";
import { LoginData } from "../types";
import {
  setAdmin,
  useLoginMutation,
  useTypedDispatch,
  useTypedSelector,
} from "../store";
import Logo from "../components/common/Logo";

const Login = () => {
  const { accessToken } = useTypedSelector((state) => state.session);
  const [login, { isLoading }] = useLoginMutation();
  const dispatch = useTypedDispatch();

  const handleSubmitForm = async (values: LoginData) => {
    const result = await login(values);
    if (!result.error && result.data) {
      dispatch(setAdmin(result.data));
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<LoginData>({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: handleSubmitForm,
  });

  if (accessToken) {
    return <Navigate to="/" />;
  }

  return (
    <div className="w-full flex h-screen">
      <form className="mx-auto w-2/5 flex flex-col items-center mt-12 gap-3">
        <Logo />
        <div className="text-start w-full text-xl mt-4 font-semibold">
          Connexion
        </div>
        <TextField
          id="email"
          value={values.email || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched}
          errors={errors}
          placeholder="Email"
        />
        <TextField
          id="password"
          value={values.password || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched}
          errors={errors}
          placeholder="Mot de passe"
          hideable
        />
        <Button
          className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
          disabled={isSubmitting || isLoading}
          type="submit"
          onClick={handleSubmit}
        >
          Se connecter
        </Button>
      </form>
    </div>
  );
};

export default Login;
